import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { BASE_URL } from "../utils/constants"

import SEO from "../components/seo"
import {
  AppCtaDesktopWrapper,
  AppCtaMobileWrapper,
} from "./AppCTABanner/staticDataWrapper"

import Loadable from "@loadable/component"

import Theme from "@airasia/phoenix-components/components/Theme"
import UniversalHeader from "@airasia/phoenix-widgets/widgets/UniversalHeader"
// import UniversalFooter from "@airasia/phoenix-widgets/widgets/UniversalFooter"
import HeroBanner from "@airasia/phoenix-widgets/widgets/HeroBanner"
import Title from "@airasia/phoenix-components/components/Title"
import Breadcrumb from "../components/breadcrumb"
// import AVAChatbot from "@airasia/phoenix-widgets/widgets/AVAChatbot"
// import EmojiScoring from "@airasia/phoenix-components/components/EmojiScoring"

import UNIVERSAL_HEADER_DATA from "../data/phoenix/universalHeader"
// import UNIVERSAL_HEADER_DATA2 from "../data/phoenix/universalHeader2"
import UNIVERSAL_FOOTER_DATA from "../data/phoenix/universalFooter"
import EMOJI_SCORING_DATA from "../data/phoenix/emojiScoring"

import { GTM_PROJECT_CATEGORY } from "../utils/constants"
import { getGtmUserType, fireGtmEvent } from "../utils/functions"
import WebVitalRUM from "@airasia/phoenix-components/components/WebVitalRUM"
// import { hyphenDelimitedLowerCase } from "../utils/functions"

// const UniversalHeader = Loadable(() =>
//   import("@airasia/phoenix-widgets/widgets/UniversalHeader")
// )
// const AVAChatbot = Loadable(() =>
//   import("@airasia/phoenix-widgets/widgets/AVAChatbot")
// )
const EmojiScoring = Loadable(() =>
  import("@airasia/phoenix-components/components/EmojiScoring")
)
const UniversalFooter = Loadable(() =>
  import("@airasia/phoenix-widgets/widgets/UniversalFooter")
)

const Wrapper = styled.div`
  max-width: 625px;
  margin: 0px 16px 24px;

  @media only screen and (min-width: 720px) {
    width: 90%;
    max-width: 976px;
    margin: 0px auto 48px;
  }

  @media only screen and (min-width: 1025px) {
    width: 90%;
    max-width: 1224px;
    margin: 0px auto 48px;
  }
`
const EmojiFeedbackWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 10px;
  align-items: center;

  @media only screen and (max-width: 768px) {
    margin: 0px 0px 10px;

    #emojiFeedbackTitle {
      margin: 0px 15px 10px;
    }
  }
`

const MobileContainer = styled.div`
  @media only screen and (min-width: 768px) {
    display: none;
  }

  #uhf-placeholder {
    height: 50px;
  }
`

const DesktopContainer = styled.div`
  @media only screen and (max-width: 768px) {
    display: none;
  }

  #uhf-placeholder {
    height: 64px;
  }
`

const Layout = ({
  pageData,
  location,
  type,
  url,
  countryUrl,
  countryName,
  children,
  includeFeedback,
}) => {
  if (location.toLowerCase() === "city") location = "Malaysia"
  const { faq, heroBanner } = pageData
  const lang = countryUrl === "/th/th/" ? "th" : "en"
  const countryURL = `/food/city${countryUrl}`
  // const url = path ? path : location.replace(/ /g, "-").toLowerCase()
  let title = `Food Delivery in ${location} | airasia Food`
  let keywords = `unlimited free delivery, free delivery, buy food ${location.toLowerCase()}, home-cooked meal, asian meal, healthy meal, western meal, vegetarian meal, online restaurant, online cafes, online meal, dessert, beverage, drinks, online delivery service, food delivery, food delivery service`
  let description = `Order food delivery in ${location} and satisfy your cravings with so many meal options to choose from. All these delivered at your doorstep! Order now!`
  // const ogImage =
  //   "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/Food_Delivery_Generic_mobile.jpg"
  let emojiText = ` How would you rate your experience on this page?`
  let emojiMaxText = "Very Satisfied"
  let emojiMinText = "Very Dissatisfied"

  // console.log("countryUrl",countryUrl)
  // console.log("url",url)

  if (url === "/th/th/" || countryUrl === "/th/th/") {
    title = `อาหารเดลิเวอรี่ใน ${location} | แอร์เอเชียฟู๊ด`
    countryName = "ประเทศไทย"
    keywords = `ส่งฟรีไม่จำกัด, ส่งฟรี, สั่งอาหาร ${location.toLowerCase()}, อาหาร home-cooked, อาหารอาเซียน, อาหารเพื่อสุขภาพ, อาหารตะวันตก, อาหารมังสวิรัติ, ร้านอาหารออนไลน์, คาเฟ่ออนไลน์, สั่งอาหารออนไลน์, อาหารว่าง, เครื่องดื่ม, น้ำดื่ม, บริการอาหารออนไลน์, อาหารเดลิเวอรี่, สั่งอาหารเดลิเวอรี่`
    description = `สั่งอาหารเดลิเวอรี่ใน ${location} อิ่มอร่อยกับรายการอาหารหลากหลายที่พร้อมให้คุณได้เลือกสรร พร้อมบริการเดลิเวอรี่จัดส่งให้ถึงหน้าบ้านคุณ! สั่งเลย!`
    emojiText = `กรุณาให้คะแนนประสบการณ์การใช้บริการหน้านี้ค่ะ`
    emojiMaxText = `พึงพอใจมาก`
    emojiMinText = `ไม่พึงพอใจ`
  }

  const AA_URL =
    process.env.GATSBY_ENV === "stg" || process.env.GATSBY_ENV === "dev"
      ? "https://www.stgairasia.com"
      : "https://www.airasia.com"
  const breadcrumb =
    type === "country"
      ? [
          {
            label: url === "/th/th/" ? "อาหาร" : "Food",
            path: AA_URL + "/food/",
          },
          {
            label: location,
            path:
              location === "Malaysia"
                ? AA_URL + `/food/city/`
                : AA_URL + `/food/city${url}`,
          },
        ]
      : [
          {
            label: countryUrl === "/th/th/" ? "อาหาร" : "Food",
            path: AA_URL + "/food/",
          },
          {
            label: countryName ? countryName : "City",
            path: AA_URL + countryURL,
          },
          {
            label: location,
            path: AA_URL + `/food/city/${url}/`,
          },
        ]

  // const avaGtmFire = () => {
  //   const obj = {
  //     event: "trackEventNoEcommerce",
  //     "eventDetails.category": `AVA Chat Bot`,
  //     "eventDetails.action": `click`,
  //     "eventDetails.label": `${GTM_PROJECT_CATEGORY} | ${getGtmUserType()}`,
  //   }
  //
  //   fireGtmEvent(obj)
  // }

  const onEmojiClicked = val => {
    const gtmEvent = {
      event: "trackEventNoEcommerce",
      "eventDetails.category": `emoji scoring`,
      "eventDetails.action": `click`,
      "eventDetails.label": `${GTM_PROJECT_CATEGORY} | ${val} | ${getGtmUserType()}`,
    }

    fireGtmEvent(gtmEvent)
  }

  const hreflangCity =
    countryName === "Thailand" || countryName === "ประเทศไทย"
      ? [
          `<link rel="alternate" hreflang="x-default" href=${BASE_URL}${url} />`,
          `<link rel="alternate" hreflang="th" href=${BASE_URL}/${location
            .replace(/ /g, "-")
            .toLowerCase()}/th/th/ />`,
          `<link rel="alternate" hreflang="en" href=${BASE_URL}/${location
            .replace(/ /g, "-")
            .toLowerCase()}/>`,
        ]
      : [
          `<link rel="alternate" hreflang="x-default" href=${BASE_URL}${url} />`,
          `<link rel="alternate" hreflang="en" href=${BASE_URL}${url} />`,
        ]
  const hrefLang =
    type === "country"
      ? [
          `<link rel="alternate" hreflang="x-default" href=${
            BASE_URL + "/"
          } />`,
          `<link rel="alternate" hreflang="en" href=${BASE_URL + "/"} />`,
          `<link rel="alternate" hreflang="en-SG" href=${BASE_URL + "/sg/"} />`,
          `<link rel="alternate" hreflang="en-TH" href=${BASE_URL + "/th/"} />`,
          `<link rel="alternate" hreflang="th-TH" href=${
            BASE_URL + "/th/th/"
          } />`,
        ]
      : hreflangCity

  return location ? (
    <Theme theme="AIRASIA_CLASSIC">
      <SEO
        title={title}
        keywords={keywords}
        description={description}
        ogImage={
          "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/Food_Delivery_Generic_mobile.jpg"
          // "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/mobile_" +
          // hyphenDelimitedLowerCase(location) +
          // ".jpg"
        }
        url={url}
        faq={faq}
        breadcrumb={breadcrumb}
        lang={lang}
        hrefLangData={hrefLang}
      />
      <WebVitalRUM fireGtm={fireGtmEvent}/>
      <MobileContainer>
        <div id="uhf-placeholder">
          <UniversalHeader
            data={
              url === "/th/th/" || countryUrl === "/th/th/"
                ? UNIVERSAL_HEADER_DATA["TH"]
                : UNIVERSAL_HEADER_DATA["EN"]
            }
            locale="en-gb"
            currency="MYR"
            environment="production"
            viewport="mobile"
            loginConfig={{
              HideLoginIconForMobile: false,
              enableBigPoints: false,
              reloadOnLoginStatusChange: true,
              shouldSetCookie: false,
            }}
            fireGtm={fireGtmEvent}
          />
        </div>
        <HeroBanner
          bannerDetails={heroBanner}
          device="mobile"
          gtmParameters={{
            event: "trackEventNoEcommerce",
            eventActionClick: "click",
            eventActionView: "view",
            eventCategory: "{{consumername}}|herobannermobile",
            eventLabelCardClick: " {{bannerid}}|{{bannerposition}} ",
            eventLabelHeadlineClick: "",
            eventLabelView: `{{bannerid}}|{{bannerposition}}`,
          }}
          onBannerClick={obj => {
            fireGtmEvent(obj)
          }}
          gtmConsumerName={GTM_PROJECT_CATEGORY}
          fireGtm={fireGtmEvent}
        />
      </MobileContainer>

      <DesktopContainer>
        <div id="uhf-placeholder">
          <UniversalHeader
            data={
              url === "/th/th/" || countryUrl === "/th/th/"
                ? UNIVERSAL_HEADER_DATA["TH"]
                : UNIVERSAL_HEADER_DATA["EN"]
            }
            locale="en-gb"
            currency="MYR"
            environment="production"
            viewport="desktop"
            loginConfig={{
              HideLoginIconForMobile: false,
              enableBigPoints: false,
              reloadOnLoginStatusChange: true,
              shouldSetCookie: false,
            }}
            fireGtm={fireGtmEvent}
          />
        </div>
        <HeroBanner
          bannerDetails={heroBanner}
          device="desktop"
          gtmParameters={{
            event: "trackEventNoEcommerce",
            eventActionClick: "click",
            eventActionView: "view",
            eventCategory: "{{consumername}}|herobanner",
            eventLabelCardClick: " {{bannerid}}|{{bannerposition}} ",
            eventLabelHeadlineClick: "",
            eventLabelView: `{{bannerid}}|{{bannerposition}}`,
          }}
          onBannerClick={obj => {
            fireGtmEvent(obj)
          }}
          gtmConsumerName={GTM_PROJECT_CATEGORY}
          fireGtm={fireGtmEvent}
        />
      </DesktopContainer>

      <Wrapper>
        {breadcrumb && (
          <div style={{ marginTop: "2%" }}>
            <Breadcrumb crumbs={breadcrumb} />
          </div>
        )}
        {children}
      </Wrapper>

      {includeFeedback && (
        <EmojiFeedbackWrapper>
          <Title
            type="h3"
            customProperties={{
              id: "emojiFeedbackTitle",
            }}
            marginBottom="XXXSmall"
          >
            {emojiText}
          </Title>
          <EmojiScoring
            data={EMOJI_SCORING_DATA}
            fullWidth={false}
            maxText={emojiMaxText}
            minText={emojiMinText}
            onEmojiClicked={onEmojiClicked}
            textColor="greyDark"
            textSize="small"
          />
        </EmojiFeedbackWrapper>
      )}

      <MobileContainer>
        {
          AppCtaMobileWrapper[
            countryUrl === "/th/th/" || url === "/th/th/" ? "/th/th/" : "/"
          ]
        }
        <UniversalFooter viewport="mobile" data={UNIVERSAL_FOOTER_DATA} />
      </MobileContainer>

      <DesktopContainer>
        {
          AppCtaDesktopWrapper[
            countryUrl === "/th/th/" || url === "/th/th/" ? "/th/th/" : "/"
          ]
        }
        <UniversalFooter viewport="desktop" data={UNIVERSAL_FOOTER_DATA} />
      </DesktopContainer>
    </Theme>
  ) : (
    <></>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

Layout.defaultProps = {
  includeFeedback: true,
}

export default Layout
